import moment from "moment";
import {getCurrentYear} from "./content";
import {toFormData} from "axios";


export const debounce = (fn: Function, ms = 300) => {
    let timeoutId: ReturnType<typeof setTimeout>;
    return function (this: any, ...args: any[]) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => fn.apply(this, args), ms);
    };
};

export const limit = (text: string | null | undefined | number, length: number = 12, last: boolean = false) => {
    if (text === null || text === undefined) return '';
    if (typeof text === 'number') text = text.toString()
    return text.length > length ? (
        !last
            ? text.slice(0, length) + '...'
            : '...' + text.slice(-1 * length)
    ) : text
}

export const normalize = (str: string) => {
    return str
        .replaceAll(' ', '_')
        .replaceAll('%', '%25')
        .replaceAll('/', '%2F')
        .replaceAll('?', '%3F')
}

export const getDates = (type: string, value: string | number | undefined = undefined, monthValue: number = 0, format = 'YYYYMMDD') => {
    let toDate = moment()
    let fromDate

    switch (type) {
        case 'last90Days': {
            fromDate = moment().subtract(90, 'day')
            break;
        }
        case 'lastMonth': {
            fromDate = moment().subtract(1, 'month')
            break;
        }
        case 'lastYear': {
            fromDate = moment().subtract(1, 'year')
            break;
        }
        case 'year': {
            fromDate = moment()
            if (!value) {
                value = getCurrentYear()
            }

            if (monthValue) {
                toDate.set('year', +value).set('month', monthValue - 1).endOf('month')
                fromDate.set('year', +value).set('month', monthValue - 1).startOf('month')
            } else {
                toDate.set('year', +value).endOf('year')
                fromDate.set('year', +value).startOf('year')
            }
            break;
        }
        default: {
            fromDate = moment().subtract(1, 'weeks')
        }
    }

    return {
        from: fromDate.format(format),
        to: toDate.format(format),
        dates: {
            from: fromDate,
            to: toDate
        }
    }
}

export const isIP = (value: string) => {
    return /^([0-9a-f]{1,4}:){7}[0-9a-f]{1,4}$/i.test(value)
        || /^([0-9]{1,3}\.){3}[0-9]{1,3}$/i.test(value)
}

export const isEmail = (value: string): boolean => {
    const validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
    return !!value.match(validRegex);
}

export const formatDate = (value: string) => {
    return moment(value).format('YYYY-MM-DD H:mm:ss')
}